const translations = {
  en: {
    duringStaySurvey: {
      alreadyAnswer: 'Thank you very much for your feedback, you opinion is extremely important to us to improve every day!',
      sendSurvey: 'Send',
      'placeholder-rating-0': ' ',
      'placeholder-rating-1': 'What could we do to improve?',
      'placeholder-rating-2': 'What could we do to improve?',
      'placeholder-rating-3': 'What could we do to improve?',
      'placeholder-rating-4': 'Thank you, would like to leave a comment?',
      'placeholder-rating-5': 'Thank you, would like to leave a comment?',
      feedbackQuestion: 'How do you rate your experience so far?',
      feedbackQuestionSubtitle: 'Your feedback is essential to us! We invite you to share with us the details of your stay experience, so that we can continue to improve our services for you and all our guests. Thank you for your support!',
      expired1: 'We are sorry, but we are currently no longer accepting survey responses as your stay has ended.',
      expired2: 'It was still a privilege to have you as a guest and we hope you enjoyed your stay.'
    }
  },
  de: {
    duringStaySurvey: {
      alreadyAnswer: 'Vielen Dank für Ihr Feedback, Ihre Meinung ist extrem wichtig, um uns jeden Tag zu verbessern!',
      sendSurvey: 'Versenden',
      'placeholder-rating-0': ' ',
      'placeholder-rating-1': 'Was können wir tun, um uns zu verbessern?',
      'placeholder-rating-2': 'Was können wir tun, um uns zu verbessern?',
      'placeholder-rating-3': 'Was können wir tun, um uns zu verbessern?',
      'placeholder-rating-4': 'Danke, möchtest du uns einen Kommentar hinterlassen?',
      'placeholder-rating-5': 'Danke, möchtest du uns einen Kommentar hinterlassen?',
      feedbackQuestion: 'Wie würden Sie Ihre bisherige Erfahrung?',
      feedbackQuestionSubtitle: 'Ihr Feedback ist für uns von großer Bedeutung! Wir laden Sie ein, uns Details Ihres Aufenthalts mitzuteilen, damit wir unsere Dienstleistungen für Sie und alle unsere Gäste weiter verbessern können. Vielen Dank für Ihre Unterstützung!',
      expired1: 'Es tut uns leid, aber wir nehmen derzeit keine Antworten mehr auf die Umfrage an, da Ihr Aufenthalt zu Ende gegangen ist.',
      expired2: 'Es war dennoch ein Privileg, Sie als Gast zu haben, und wir hoffen, dass Sie Ihren Aufenthalt genossen haben.'
    }
  },
  es: {
    duringStaySurvey: {
      alreadyAnswer: 'Muchas gracias por proporcionarnos comentarios, ¡su opinión es extremadamente importante para mejorarnos cada día!',
      sendSurvey: 'Mandar',
      'placeholder-rating-0': ' ',
      'placeholder-rating-1': '¿Qué podemos hacer para mejorar?',
      'placeholder-rating-2': '¿Qué podemos hacer para mejorar?',
      'placeholder-rating-3': '¿Qué podemos hacer para mejorar?',
      'placeholder-rating-4': 'Gracias, ¿quieres dejarnos un comentario?',
      'placeholder-rating-5': 'Gracias, ¿quieres dejarnos un comentario?',
      feedbackQuestion: '¿Cómo valoras tu experiencia hasta ahora?',
      feedbackQuestionSubtitle: 'Tu retroalimentación es fundamental para nosotros. Te invitamos a compartir con nosotros los detalles de tu experiencia de estadía, para que podamos seguir mejorando nuestros servicios para ti y para todos nuestros huéspedes. ¡Gracias por tu apoyo!',
      expired1: 'Lo sentimos, pero ya no aceptamos respuestas a la encuesta, ya que su estancia se acabό.',
      expired2: 'Fue un privilegio acogerla y esperamos que su estancia fue agradable.'
    }
  },
  fr: {
    duringStaySurvey: {
      alreadyAnswer: 'Merci beaucoup de nous avoir fourni des commentaires, votre avis est extrêmement important pour nous améliorer chaque jour!',
      sendSurvey: 'Envoyer',
      'placeholder-rating-0': ' ',
      'placeholder-rating-1': 'Que pouvons-nous faire pour nous améliorer?',
      'placeholder-rating-2': 'Que pouvons-nous faire pour nous améliorer?',
      'placeholder-rating-3': 'Que pouvons-nous faire pour nous améliorer?',
      'placeholder-rating-4': 'Merci, voulez-vous nous laisser un commentaire?',
      'placeholder-rating-5': 'Merci, voulez-vous nous laisser un commentaire?',
      feedbackQuestion: 'Comment évaluez-vous votre expérience jusqu’à présent?',
      feedbackQuestionSubtitle: 'Votre avis est fondamental pour nous! Nous vous invitons à partager avec nous les détails de votre séjour, afin de continuer à améliorer nos services pour vous et tous nos invités. Merci pour votre soutien!',
      expired1: 'Nous sommes désolés, mais nous n\'acceptons plus de réponses à l\'enquête, car votre séjour est terminé.',
      expired2: 'Ce fut néanmoins un privilège de vous recevoir et nous espérons que vous avez apprécié votre séjour.'
    }
  },
  it: {
    duringStaySurvey: {
      alreadyAnswer: 'Grazie mille per averci fornito il feedback, la tua opinione è estremamente importante per migliorarci ogni giorno!',
      sendSurvey: 'Invia',
      'placeholder-rating-0': ' ',
      'placeholder-rating-1': 'Cosa possiamo fare per migliorarci?',
      'placeholder-rating-2': 'Cosa possiamo fare per migliorarci?',
      'placeholder-rating-3': 'Cosa possiamo fare per migliorarci?',
      'placeholder-rating-4': 'Grazie, vuoi lasciarci un commento?',
      'placeholder-rating-5': 'Grazie, vuoi lasciarci un commento?',
      feedbackQuestion: 'Come valuti la tua esperienza finora?',
      feedbackQuestionSubtitle: 'Il tuo feedback è fondamentale per noi! Ti invitiamo a condividere con noi i dettagli della tua esperienza di soggiorno, in modo da continuare a migliorare i nostri servizi per te e per tutti i nostri ospiti. Grazie per il tuo supporto!',
      expired1: 'Siamo spiacenti, ma attualmente non accettiamo più risposte al sondaggio, in quanto il tuo soggiorno si è concluso.',
      expired2: 'È stato comunque un privilegio averti come ospite e speriamo che il soggiorno sia stato di tuo gradimento.'
    }
  }
};

export default translations;



// WEBPACK FOOTER //
// ./translations/during-stay-survey/DuringStaySurvey.js